import BillingMethod from 'billing/models/BillingMethod'
import Job from 'jobs/Job'
import BillingStore from 'billing/BillingStore'

/**
 * Adapter for the Close Job Dialog modal.
 */
export function CloseJobDialogAdapter(
  billingStore: BillingStore,
  job: Job,
): CloseJobDialogPorts {
  return {
    async fetchBillingProfiles() {
      if (!job.isBillingEnabled) {
        return
      }

      if (job.ownerTeam?.id) {
        await billingStore.fetchBillingProfileForTeam(job.ownerTeam.id)
      }

      await billingStore.fetchBillingProfileForIndividual(
        job.workspace.id,
        job.owner.user.publicId,
      )
    },

    getBillingMethods() {
      return job.ownerTeam
        ? billingStore.billingMethodsForTeam(job.ownerTeam)
        : billingStore.billingMethodsForIndividual(job.owner)
    },
  }
}

/**
 * Ports for the CloseJobDialog.
 */
export interface CloseJobDialogPorts {
  /**
   * Fetches billing profiles for the job.
   */
  fetchBillingProfiles(): Promise<void>

  /**
   * Returns available billing methods for the given job.
   */
  getBillingMethods(): BillingMethod[]
}
